import { fetchData, postData, putData, deleteData } from '@jda/lui-portal-utilities';

import { getAuthToken } from '../auth/authProvider';
import { convertObjectToQueryString, createRequestObject, getAPIMUrl } from '../utility/commonUtility';
import { ICreateUserGroupRequest } from '../models/UserGroups/UserGroupsContract';

const { GROUP_MANAGEMENT_SERVICE } = window['env'];

export const getAllUserGroupsRequest = async (query: any) => {
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups`;
  if (query.pageNumber) {
    apiURL = apiURL + `?page-number=${query.pageNumber}`;
  }
  if (query.pageSize) {
    apiURL = apiURL + `&page-size=${query.pageSize}`;
  }
  if (query.searchValue) {
    apiURL = apiURL + `&filter-identifierOrDisplayName=${query.searchValue}`;
  }
  return fetchData<any[]>(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const getUsersByGroup = async (identifier: any, queryParams: any) => {
  let queryData = '';
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups/${identifier}/subjects`;
  if (queryParams && typeof queryParams === 'object') {
    queryData = convertObjectToQueryString(queryParams);
    apiURL = `${apiURL}?${queryData}`;
  }

  return fetchData<any[]>(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const createUserGroupRequest = async (data: ICreateUserGroupRequest) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups`;
  return postData<any>(createRequestObject(apiURL), data, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};
;
export const addUsersToGroup = async (identifier: string, ids: any) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups/${identifier}/subjects`;
  const data = {
    subjectIds: [...ids]
  }
  return postData<any>(createRequestObject(apiURL), data, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const deleteUserFromGroup = async (identifier: string, ids: any) => {
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups/${identifier}/subjects`;
  const data = {
    subjectIds: [...ids]
  }
  return deleteData(createRequestObject(apiURL), data, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const getUserGroupByIdentifierRequest = async (identifier: string) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups/${identifier}`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const updateUserGroupRequest = async (data: ICreateUserGroupRequest) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups/${data.identifier}`;
  return putData<any>(createRequestObject(apiURL), data, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const deleteUserGroupRequest = async (identifier: string) => {
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups/${identifier}`;
  return deleteData(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const getRolesAssignedToGroups = async (identifier: string) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups/${identifier}/roles?page-number=1&page-size=1000&sort-order=ASC`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const assignRolesToGroupsRequest = async (identifier: string, data: any) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups/${identifier}/roles`;
  return postData<any>(createRequestObject(apiURL), data, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const deleteRolesToGroupsRequest = async (identifier: string, data: any) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${GROUP_MANAGEMENT_SERVICE}/groups/${identifier}/roles`;
  return deleteData<any>(createRequestObject(apiURL), data, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};